import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { UI_HEIGHT } from '../Common/constants';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, Table, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';

class Agents extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            rows: [],
            selectedRows: null,
            filters: {},
            sortColumn: null,
            sortDirection: null,
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchAgents();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    componentDidUpdate() {
    }

    // Once groups is ready, reset state.

    componentWillReceiveProps(nextProps) {
        if (nextProps.agents && nextProps.agents != this.props.agents) {
            this.setState({
                rows: nextProps.agents
            });
        }
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton});
    }

    // Set agent being selected to be currentAgent and navigate user to the edit page

    setCurrentAgent(e) {
        e.preventDefault();
        const currentAgent = this.state.selectedRows[0];
        this.props.resetCurrentAgent();
        this.props.selectAgent(currentAgent);
        this.context.router.push('/agents/'+currentAgent.Agent_id);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentAgent();
        this.context.router.push('/agents/new')
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }

            //Custom Formatter component
            const IsActiveFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className="label label-success"><Translate value="active" /></span>;
                    else return <span className="label label-danger"><Translate value="inactive" /></span>;
                }
            });

            // Handle the row select function

            const onRowSelect = rows => {
                this.setState({ selectedRows: rows });
            }

            // Column difinition

            const columns = [
                {
                    key: 'AgentNum',
                    name: <Translate value="agent_num" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 80,
                },
                {
                    key: 'Name',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 150,
                },
                {
                    key: 'Description',
                    name: <Translate value="description" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 100,
                },
                {
                    key: 'PaymentTerm_id',
                    name: <Translate value="payment_term" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 150,
                },
                {
                    key: 'CreditStatus',
                    name: <Translate value="credit_status" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 100,
                },
                {
                    key: 'IsActive',
                    name: <Translate value="active" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 80,
                    formatter: IsActiveFormatter
                }
            ]

            return (
                <Row><Col sm={ 12 }><div id="agents-dataGrid1">
                    <ReactDataGrid
                        rowKey='Agent_id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={this.state.tableHeight}
                        enableRowSelect='single'
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect}
                      />
                </div></Col></Row>
            )
        }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
      let height = (this.state.tableHeight + 130).toString();
      let tableCollapseFix = {height: height};
        return (
          //---------------
          // Begin HTML: Create New/Edit agent
          //---------------
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="general_management" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active="true">
                  <Translate value="agents"/>
                </Breadcrumb.Item>
              </Breadcrumb>
                {/* <div className="content-heading"><Translate value="agents" /></div> */}
              <Grid fluid="true" id="agents-page">
                <Row>
                  <Col md={ 12 }>
                    <Panel className="position-relative" style={ tableCollapseFix }>
                      <Row>
                          <Button
                              bsStyle="primary"
                              className="marginLeftStyle"
                              onClick={(event) => { this.clickNew(event) } }
                              disabled={this.checkPermission("add_agent")}>
                              <em className="fa fa-plus marginRightStyle"/><Translate value="add_agent" />
                          </Button>
                          <Button
                              bsStyle="primary"
                              className="marginLeftStyle"
                              onClick={(event) => { this.setCurrentAgent(event) } }
                              disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}>
                              <em className="fa fa-pencil marginRightStyle"/><Translate value="edit_agent" />
                          </Button>
                      </Row>
                      <br/>
                      {this.renderTable() }
                    </Panel>
                  </Col>
                </Row>
            </Grid>
            </ContentWrapper>
        );
    }
}



export default Agents;



// WEBPACK FOOTER //
// ./master/jsx/components/Agents/agents.jsx